import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-design-type-renderer',
  template: `
    <div class="design-type-renderer" [title]="getTooltip()">
      <span 
        nz-icon 
        [nzType]="getIconType()" 
        [nzTheme]="'outline'"
        class="design-type-icon"
        [class.video-icon]="isVideo"
        [class.design-icon]="!isVideo">
      </span>
      <span class="design-type-text">{{ getDisplayText() }}</span>
    </div>
  `,
  styles: [`
    .design-type-renderer {
      display: flex;
      align-items: center;
      gap: 6px;
      height: 100%;
    }
    
    .design-type-icon {
      font-size: 16px;
      transition: color 0.3s ease;
    }
    
    /* Light theme colors */
    .video-icon {
      color: #1677ff;
    }
    
    .design-icon {
      color: #52c41a;
    }
    
    .design-type-text {
      font-size: 12px;
      color: #666666;
      transition: color 0.3s ease;
    }
    
    /* Dark theme colors */
    :host-context(.darkmode) .design-type-text {
      color: #d9d9d9;
    }
    
    :host-context(.darkmode) .video-icon {
      color: #69b1ff;
    }
    
    :host-context(.darkmode) .design-icon {
      color: #95de64;
    }
    
    /* Hover effects for light theme */
    .design-type-renderer:hover .video-icon {
      color: #4096ff;
    }
    
    .design-type-renderer:hover .design-icon {
      color: #73d13d;
    }
    
    /* Hover effects for dark theme */
    :host-context(.darkmode) .design-type-renderer:hover .video-icon {
      color: #91caff;
    }
    
    :host-context(.darkmode) .design-type-renderer:hover .design-icon {
      color: #b7eb8f;
    }
  `]
})
export class DesignTypeRendererComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public isVideo: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isVideo = this.checkIfVideo();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.isVideo = this.checkIfVideo();
    return true;
  }

  private checkIfVideo(): boolean {
    const designType = this.params.value || this.params.data?.designType || '';
    return designType.toLowerCase().includes('video');
  }

  getIconType(): string {
    return this.isVideo ? 'video-camera' : 'picture';
  }

  getDisplayText(): string {
    const designType = this.params.value || this.params.data?.designType || '';
    
    if (this.isVideo) {
      return 'Video';
    } else {
      return 'Image';
    }
  }

  getTooltip(): string {
    const designType = this.params.value || this.params.data?.designType || '';
    return `Design Type: ${designType || 'Unknown'}`;
  }
}
